import { createFeature, createReducer, on } from '@ngrx/store';
import { SupplierModel } from '@shared/data-access/models';
import { SupplierAction } from '../actions';

export const featureName = 'supplier';

export interface SupplierState {
  item: SupplierModel | null;
}
export const initialState: SupplierState = {
  item: null,
};
export const supplierFeature = createFeature({
  name: featureName,
  reducer: createReducer(
    initialState,
    on(SupplierAction.loadItemSuccess, (state, prop: { item: SupplierModel }) => ({ ...state, item: prop.item }))
  ),
});

export const {
  name, // feature name
  reducer, // feature reducer
} = supplierFeature;
